import { BaseApi } from '@/helpers/base-api'

export default class LabelApi extends BaseApi {
  constructor () {
    super('/api/v1/labels')
    this.errorMessage = 'There was an issue when trying to fetch the labels. If this error persists, please contact our support.'
  }

  public checkLabelExistence = (data: CheckLabelExistenceDto): Promise<boolean> => this.instance.post('/exists', data);

  public getAllExpenseLabels = (): Promise<LabelDto[]> => this.instance.get('/expenses');
  public createExpenseLabel = (data: CreateLabelDto): Promise<JSON> => this.instance.post('/expenses', data);
  public updateExpenseLabel = (label_id: number, data: UpdateLabelDto): Promise<JSON> => this.instance.patch(`/expenses/${label_id}`, data);
  public deleteExpenseLabel = (label_id: number): Promise<JSON> => this.instance.delete(`/expenses/${label_id}`);
}